module.exports = __webpack_public_path__ + "img/ECatapult64_ua.cb1b611f.webp";